
import { Button } from "@/components/ui/button";
import { Trash2, Lock, Link2 } from "lucide-react";
import { EditProductDialog } from "@/components/EditProductDialog";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

interface ProductActionsProps {
  id: string;
  title: string;
  description: string;
  features: string;
  link: string;
  logo: string;
  product_screen: string;
  isVisible: boolean;
  hasSubscriptions: boolean;
  onDelete: (id: string) => void;
  onUpdate: () => void;
}

export const ProductActions = ({
  id,
  title,
  description,
  features,
  link,
  logo,
  product_screen,
  isVisible,
  hasSubscriptions,
  onDelete,
  onUpdate
}: ProductActionsProps) => {
  return (
    <div className="flex gap-2">
      {link && (
        <Button
          variant="ghost"
          size="icon"
          className="text-primary hover:text-primary/80"
          onClick={() => window.open(link, '_blank')}
        >
          <Link2 className="h-4 w-4" />
        </Button>
      )}
      <EditProductDialog
        productId={id}
        initialValues={{
          name: title,
          description,
          features,
          link,
          logo,
          product_screen,
          visible: isVisible
        }}
        onProductUpdated={onUpdate}
      />
      {hasSubscriptions ? (
        <Button
          variant="ghost"
          size="icon"
          className="text-gray-400 cursor-not-allowed"
          disabled
          title="Product cannot be deleted - active subscriptions exist"
        >
          <Lock className="h-4 w-4" />
        </Button>
      ) : (
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="text-red-500 hover:text-red-700"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Are you sure?</AlertDialogTitle>
              <AlertDialogDescription>
                This action cannot be undone. This will permanently delete the product "{title}".
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction
                onClick={() => onDelete(id)}
                className="bg-red-500 hover:bg-red-600"
              >
                Delete
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </div>
  );
};
